import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CategoryHOF, CategoryTags } from 'app/categories/category';
import { CategoryHOFService } from 'app/_services/category-hof.service';
import { DialogsService } from 'app/_services/dialogs/dialogs.service';
import { HallOfFamesService } from 'app/_services/hallOfFames.service';
import { NotificationService } from 'app/_services/notification.service';
import { EditHallOfFameMemberDialogComponent } from './edit-hall-of-fame/edit-hall-of-fame.component';
import { HallOfFames } from './hall-of-fame';

@Component({
    selector: 'app-hall-of-fame',
    templateUrl: './hall-of-fame.component.html',
    styleUrls: ['../shared/table-defaults.scss', './hall-of-fame.component.scss'],
})
export class HallOfFameComponent implements OnInit {
    value = '';
    hallOfFames: HallOfFames[];
    memberNames: string[];
    categories: CategoryTags[];
    categoryNames: string[];
    dataSource: MatTableDataSource<HallOfFames>;
    selection = new SelectionModel<HallOfFames>(true, []);
    removeItems = false;

    columnChoices: string[] = [
        'Categories',
        'Id',
        'Prefix',
        'First',
        'Middle',
        'Nickname',
        'Last',
        'Suffix',
        'Title',
        'Inducted',
        'Status',
        'School',
        'Year',
        'Bio',
        'PhotoUrl',
    ];
    selectedColumns = [
        'Categories',
        'Prefix',
        'First',
        'Last',
        'Suffix',
        'Title',
        'Inducted',
        'Status',
        'School',
        'Year',
    ];
    displayedColumns = ['actions', ...this.selectedColumns];
    columnsToDisplay = this.displayedColumns.slice();

    @ViewChild(MatTable) table: MatTable<HallOfFames[]>;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    constructor(
        private hallOfFamesService: HallOfFamesService,
        private categoryHOFService: CategoryHOFService,
        private dialog: MatDialog,
        private dialogSerivce: DialogsService,
        public notificationService: NotificationService
    ) {}

    ngOnInit(): void {
        // this.categories = this.dataService.HallOfFameCategories;
        // this.categoryNames = this.dataService.getListOfHallOfFameMembers();

        this.categoryHOFService.getCategories().subscribe((categories) => {
            this.categories = categories.map((cat: CategoryHOF) => new CategoryTags(cat.categoryName, cat.hofcategoryId));
            this.categoryNames = this.categories.map((cat) => cat.name);
        });

        this.hallOfFamesService.getHallOfFames().subscribe((data) => {
            this.hallOfFames = data;
            this.loadDatasource(this.hallOfFames);
            this.setSortAndPagination();
        });
    }

    loadDatasource(data: HallOfFames[]): void {
        this.dataSource = new MatTableDataSource(data);
    }

    setSortAndPagination(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    newHallOfFame(): HallOfFames {
        return {
            hallOfFameId: 0, // Database has this columns set as Identity, so value be set to 0 for new entries
            prefix: '',
            firstName: '',
            middleName: '',
            nickname: '',
            lastName: '',
            suffix: '',
            title: '',
            inducted: '',
            status: '',
            school: '',
            year: '',
            bio: '',
            photoUrl: '',
            hofcategoryHallOfFame: [],
        };
    }

    openEditMemberDialog(hallOfFame: HallOfFames, title: string): MatDialogRef<EditHallOfFameMemberDialogComponent> {
        const config: MatDialogConfig = {
            width: '80vw',
            maxWidth: '600px',
            panelClass: 'calendarEventEditor',
            data: { hallOfFame, title },
        };

        return this.dialog.open(EditHallOfFameMemberDialogComponent, config);
    }

    addHallOfFame(): void {
        const title = 'Add New Hall of Fame Member';
        const hallOfFame = this.newHallOfFame();
        const hallOfFames = this.hallOfFames;

        const dialogResult = this.openEditMemberDialog(hallOfFame, title);

        dialogResult.afterClosed().subscribe((result: HallOfFames) => {
            if (!result) {
                return;
            }

            this.hallOfFamesService.createHallOfFame(result).subscribe((res: HallOfFames) => {
                hallOfFames.push(result);
                this.loadDatasource(hallOfFames);
                this.setSortAndPagination();
                this.notificationService.showSuccess(`New Hall of Fame Member has been added.`);
            });
        });
    }

    editHallOfFame(member: HallOfFames): void {
        const title = 'Edit Hall of Fame Member';

        const dialogResult = this.openEditMemberDialog(member, title);

        dialogResult.afterClosed().subscribe((result: HallOfFames) => {
            if (!result) {
                return;
            }

            this.hallOfFamesService.updateHallOfFame(result.hallOfFameId, result).subscribe();
            this.setSortAndPagination();
            this.notificationService.showSuccess(`Hall of Fame Member has been updated.`);
        });
    }

    deleteHallOfFame(hallOfFame: HallOfFames): void {
        const dialogResult$ = this.dialogSerivce.OpenConfirmationDialog({
            TitleText: 'Delete Hall of Fame Member',
            MessageText:
                `Are you sure you want to delete this Hall of Fame member? Deleting the Hall of Fame member will also remove all 
                 categories listed for that Hall of Fame member. THIS CANNOT BE UNDONE!`,
            OKText: 'Yes, remove member',
            CancelText: 'No',
        });

        dialogResult$.subscribe((result) => {
            if (!result) {
                return;
            }

            const index = this.dataSource.data.indexOf(hallOfFame, 0);

            if (index > -1) {
                this.dataSource.data.splice(index, 1);
            }

            this.hallOfFamesService.deleteHallOfFame(hallOfFame.hallOfFameId).subscribe();
            this.table.renderRows();
            this.setSortAndPagination();
            this.notificationService.showSuccess(`Hall of Fame member have been removed.`);
        });
    }

    applyFilter(searchTerms: any): void {
        this.dataSource.filter = searchTerms;

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    clearFilter(): void {
        this.dataSource.filter = '';

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
}
